import React, { useEffect, useRef, MouseEvent, SyntheticEvent } from 'react';
import { Header, Navigation } from 'festo-react-ui-kit';
import { useDispatch } from 'react-redux';
import { fetchTranslations } from '../features/translation/translationSlice';
import Headline from '../components/Headline/Headline';
import MediaResistance from '../features/media-resistance/MediaResistance';
import { RequestHandler } from './RequestHandler';
import FilterList from '../features/filter/FilterList';
import { buildQuery } from '../components/QueryBuilder';
import { HeaderOverride } from '../headerOverride';
import './App.scss';
import ShareLink from '../components/ShareLink/ShareLink';
import { useAppDispatch, useAppSelector } from './hooks';

export function routePrefix(): string {
  const requestHandler = new RequestHandler();
  const prefix = `/eac/${requestHandler.language}_${requestHandler.country}/media-resistance-backend/`;
  /* let prefix = `${process.env.REACT_APP_BACKEND_PATH_LOCAL_REGEX}/`;
  if (requestHandler.applicationType != 'local') {
    prefix = `/eac/${requestHandler.language}_${requestHandler.country}${process.env.REACT_APP_BACKEND_PATH_LOCAL_REGEX}/`;
  } */
  return prefix;
}

function App(): JSX.Element {
  const dispatch = useDispatch();
  const requestHandler = new RequestHandler();
  const translations = useAppSelector((state) => state.translation.value);

  const { applicationType } = requestHandler;
  let { country, language } = requestHandler;
  if (applicationType !== 'local') {
    language = '';
    country = '';
  }
  useEffect(() => {
    const query = buildQuery({ country: country, language: language });
    dispatch(fetchTranslations(query));
  }, [dispatch, country, language]);

  const tableSectionRef = useRef<HTMLDivElement>(null);

  return (
    <div className="container-body">
      {Object.keys(translations).length > 0 && (
        <>
          <HeaderOverride />
          {applicationType !== 'fox' && (
            <Header>
              <Navigation logoHref="festo.com" logoSrc="./logo_blue.svg" />
            </Header>
          )}
          <Headline />
          <section className="container-fluid row-eq-height fwe-mb-6">
            <div className="main-section">
              <ShareLink />
              <FilterList language={language} tableRef={tableSectionRef} />
              <MediaResistance language={language} ref={tableSectionRef} />
            </div>
          </section>
        </>
      )}
    </div>
  );
}

export default App;
